import { DATE_OFFSET_TYPE } from './dates';

export const MESSAGE_CHANNEL_ENUM = {
  EMAIL: 'EMAIL',
  PUSH: 'PUSH',
  SMS: 'SMS',
};

export const BROADCAST_TYPE_ENUM = {
  DAILY_UPDATE: 'DAILY_UPDATE',
  GENERIC: 'GENERIC',
  SECURITY_ALERT: 'SECURITY_ALERT',
  WEATHER_ALERT: 'WEATHER_ALERT',
  WEEKLY_UPDATE: 'WEEKLY_UPDATE',
  MATCHED_PHOTOS_MARKETING: 'MATCHED_PHOTOS_MARKETING',
  IDENTITY_TAGS_CONFIGURATION: 'IDENTITY_TAGS_CONFIGURATION',
  SELFIE_REQUEST: 'SELFIE_REQUEST',
};

export const BROADCAST_TEMPLATE_KEYS = {
  SELFIE_REQUEST_PURCHASED: 'SELFIE_REQUEST_PURCHASED',
  SELFIE_REQUEST_NON_PURCHASED: 'SELFIE_REQUEST_NON_PURCHASED',
  ROSTER_ACCOUNT_UNCLAIMED: 'ROSTER_ACCOUNT_UNCLAIMED',
  SELFIE_UPDATE: 'SELFIE_UPDATE',
  PROMO_1_DEADLINE: 'PROMO_1_DEADLINE',
  PROMO_2_DEADLINE: 'PROMO_2_DEADLINE',
  PROMO_3_NO_DEADLINE: 'PROMO_3_NO_DEADLINE',
  NO_PHOTOS_FOUND: 'NO_PHOTOS_FOUND',
  WRONG_ALBUM_JOIN: 'WRONG_ALBUM_JOIN',
  SELFIE_UPDATE_CAMPS: 'SELFIE_UPDATE_CAMPS',
  SELFIE_REQUEST_CLAIMED_CAMPS: 'SELFIE_REQUEST_CLAIMED_CAMPS',
  SELFIE_REQUEST_UNCLAIMED_CAMPS: 'SELFIE_REQUEST_UNCLAIMED_CAMPS',
  SELFIE_UPDATE_SCHOOLS: 'SELFIE_UPDATE_SCHOOLS',
  SELFIE_REQUEST_CLAIMED_SCHOOLS: 'SELFIE_REQUEST_CLAIMED_SCHOOLS',
  SELFIE_REQUEST_UNCLAIMED_SCHOOLS: 'SELFIE_REQUEST_UNCLAIMED_SCHOOLS',
  SELFIE_UPDATE_PRO: 'SELFIE_UPDATE_PRO',
  SIGNUP_REQUEST_PRO: 'SIGNUP_REQUEST_PRO',
  EVENT_REMINDER: 'EVENT_REMINDER',
  BLANK: 'BLANK',
};

export const MESSAGE_CHANNEL_OPTIONS = [
  {
    label: 'SMS or Email (SMS as priority)',
    value: 'EMAIL_SMS_SMS_FIRST',
    input: {
      mandatory_channels: [],
      optional_channels: [MESSAGE_CHANNEL_ENUM.SMS, MESSAGE_CHANNEL_ENUM.EMAIL],
    },
  },
  {
    label: 'Email or SMS (Email as priority)',
    value: 'EMAIL_SMS_EMAIL_FIRST',
    input: {
      mandatory_channels: [],
      optional_channels: [MESSAGE_CHANNEL_ENUM.EMAIL, MESSAGE_CHANNEL_ENUM.SMS],
    },
  },
  {
    label: 'Email & SMS',
    value: 'EMAIL_SMS',
    input: {
      mandatory_channels: [
        MESSAGE_CHANNEL_ENUM.EMAIL,
        MESSAGE_CHANNEL_ENUM.SMS,
      ],
      optional_channels: [],
    },
  },
  {
    label: 'Email only',
    value: 'EMAIL_ONLY',
    input: {
      mandatory_channels: [],
      optional_channels: [MESSAGE_CHANNEL_ENUM.EMAIL],
    },
  },
  {
    label: 'SMS Only',
    value: 'SMS_ONLY',
    input: {
      mandatory_channels: [],
      optional_channels: [MESSAGE_CHANNEL_ENUM.SMS],
    },
  },
];

export const ALBUM_FOLDER_BROADCAST_SEQUENCE_STATUS_ENUM = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  COMPLETED: 'COMPLETED',
};

// Stopgap until email and SMS bodies are split; spans three GSM-7 SMS segments (153 characters each).
export const BROADCAST_MESSAGE_CHARACTER_LIMIT = 350;

export const SMS_NO_EMOJIS_NOTE =
  "Emojis aren't supported in SMS messages and are removed automatically.";

// Offset types a pro can pick for a new sequence step. Older steps may still
// carry the retired DAYS_AFTER_EVENT* / DAYS_AFTER_FIRST_PHOTO_PUBLISH types.
export const SEQUENCE_STEP_OFFSET_TYPES = [
  DATE_OFFSET_TYPE.DAYS_BEFORE_EVENT,
  DATE_OFFSET_TYPE.DAYS_AFTER_FIRST_MATCH,
  DATE_OFFSET_TYPE.SCHEDULED_AT,
];

// Every offset type that lands after the event has started, i.e. after the
// first match message in the sequence overview.
export const POST_EVENT_OFFSET_TYPES = [
  DATE_OFFSET_TYPE.DAYS_AFTER_EVENT,
  DATE_OFFSET_TYPE.DAYS_AFTER_EVENT_START,
  DATE_OFFSET_TYPE.DAYS_AFTER_FIRST_PHOTO_PUBLISH,
  DATE_OFFSET_TYPE.DAYS_AFTER_FIRST_MATCH,
];
